/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Feature Detection

At the time of writing, we only need to detect the following features in order to make the allink-core-static work.

*/

$(function(){

    //  Swop class if JavaScript is enabled
    $('html').removeClass('no-js').addClass('js');

});



// WEBPACK FOOTER //
// ./~/allink-core-static/js/modules/feature-detection.js